var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EmptyState',{attrs:{"image":"error","imageAlt":_vm.$t('global.error'),"boldMessage":_vm.$t('global.error-state-generic')}})}
var staticRenderFns = []

export { render, staticRenderFns }